<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>

                <v-toolbar card prominent>
                    <v-sheet width="120" color="rgba(0,0,0,0)">
                        <v-text-field
                            v-model="amount"
                            :label="$t('amount')"
                            type="number"
                        ></v-text-field>
                    </v-sheet>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="startTests"
                                :disabled="state=='run'"
                            >
                                <v-icon>mdi-play</v-icon>
                                <span>{{ $t("start") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("start") }}</span>
                    </v-tooltip>

                    <!--
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="pauseTests"
                                :disabled="state !== 'run'"
                            >
                                <v-icon>mdi-pause</v-icon>
                                <span>{{ $t("pause") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("pause") }}</span>
                    </v-tooltip>
                    -->

                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="stopTests"
                                :disabled="state == 'stopped'"
                            >
                                <v-icon>mdi-stop</v-icon>
                                <span>{{ $t("stop") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("stop") }}</span>
                    </v-tooltip>
                </v-toolbar>

                <v-card-text class="v-scrollable">
                    <v-layout row wrap mb-2>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0">
                                <v-card-title>
                                    <span class="font-weight-black">{{ $t("catalogs") }}</span>
                                </v-card-title>
                                <v-card-text class="dense">
                                    <v-checkbox
                                        v-model="tests.catalogs.equipment"
                                        primary
                                        hide-details
                                        :label="$t('equipment')"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="tests.catalogs.lengths"
                                        primary
                                        hide-details
                                        :label="$t('lengths')"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="tests.catalogs.lumber"
                                        primary
                                        hide-details
                                        :label="$t('lumber')"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="tests.catalogs.prices"
                                        primary
                                        hide-details
                                        :label="$t('prices')"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="tests.catalogs.species"
                                        primary
                                        hide-details
                                        :label="$t('species')"
                                    ></v-checkbox>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0">
                                <v-card-title>
                                    <span class="font-weight-black">{{ $t("libraries") }}</span>
                                </v-card-title>
                                <v-card-text class="dense">
                                    <v-checkbox
                                        v-model="tests.libraries.patterns"
                                        primary
                                        hide-details
                                        :label="$t('patterns')"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="tests.libraries.threeD"
                                        primary
                                        hide-details
                                        label="3D"
                                    ></v-checkbox>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0">
                                <v-card-title>
                                    <span class="font-weight-black">{{ $t("calculations") }}</span>
                                </v-card-title>
                                <v-card-text class="dense">
                                    <v-checkbox
                                        v-model="tests.calculations.optimization"
                                        primary
                                        hide-details
                                        :label="$t('optimization')"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="tests.calculations.diamOptimization"
                                        primary
                                        hide-details
                                        :label="$t('findingTheOptimalDiameter')"
                                    ></v-checkbox>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <!--
                    <v-layout row wrap mb-2>
                        <v-flex xs12 md6>
                            <v-text-field
                                :value="amount"
                                :label="$t('amount')"
                                type="number"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    -->
                    <v-layout row wrap mb-2>
                        <v-textarea
                            v-model="testReport"
                            rows="10"
                            :label="$t('testReport')"
                        ></v-textarea>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="clearDataClick">{{ $t("clear") }}</v-btn>
                </v-card-actions>
            </v-card>
            <message-box ref="MessageBox"/>
            <message-dialog ref="MessageDialog"/>
            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox    from "@/components/dialogs/MessageBox";
    import MessageDialog from "@/components/dialogs/MessageDialog";

    export default {
        name: "LoadTesting",

        components: {
            MessageBox,
            MessageDialog
        },

        data () {
            return {
                alert:     "",
                alertType: "success",
                breadCrumbs: [
                    { text: "Нагрузочное тестирование", disabled: false },
                ],
                amount:        1000,
                boardsCentral: [],
                boardsSide:    [],
                dialogWatcher: null,
                loading: {
                    lumberInfo: false,
                    models:     false,
                    patterns:   false,
                    profile:    false,
                    profiles:   false,
                },
                models:     [],
                patterns:   [],
                profiles:   [],
                speciesId:  1,
                state:      "stopped",
                testReport: "",
                tests: {
                    calculations: {
                        optimization:     true,
                        diamOptimization: true
                    },
                    catalogs: {
                        equipment: true,
                        lengths:   true,
                        lumber:    true,
                        prices:    true,
                        species:   true,
                    },
                    libraries: {
                        patterns: true,
                        threeD:   true,
                    }
                },
                testsDuration: 0
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.lumberInfo || this.loading.models || this.loading.patterns || this.loading.profile || this.loading.profiles;
            }
        },

        async mounted () {
            this.applyLocale();
            // TODO recapctha, на данный момент не работает
            // await this.$recaptchaLoaded();
            // const recaptcha = this.$recaptchaInstance;
            // recaptcha.hideBadge();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.loadModels();
            this.loadProfiles();
            this.loadPatterns();
            this.loadLumber();
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("loadTesting"), disabled: false }
                ];
            },

            /**
             * Вызов внешнего приложения
             *
             * @param {number} taskId Идентификатор задачи
             */
            async callExternalApp (taskId) {
                this.loading.calculationResult = true;

                await this.axios.get(`${this.$config.apiURL}calc/?task=${taskId}`, { withCredentials: true })
                    .then(() => {
                        this.testReport += "callExternalApp: Ok";
                    })
                    .catch(error => {
                        this.testReport += `callExternalApp: ${this.$t("error")}`;
                        this.testReport += `\r\n${JSON.stringify(error)}`;
                    });
            },

            /**
             * Запуск тестирования справочника
             *
             * @param {string} catalog Справочник
             */
            async catalogTest (catalog) {
                let totalTime = 0;

                this.testReport += `\r\n\r\n${this.$t("test")} "${this.$t(catalog)}" ${this.$t("started").toLowerCase()}`;

                if (this.state == "stopped") { return; }

                for (let i = 0; i < this.amount; i++) {
                    let startTime = Date.now();

                    await this.axios.get(`${this.$config.apiURL}${catalog}/`, { withCredentials: true })
                        .then(() => {
                            this.testReport += `\r\n${i + 1}. URI: ${this.$config.apiURL}${catalog}/ ${this.$t("executionTime")}: ${Date.now() - startTime} ${this.$t("ms")}. ${this.$t("status")}: Ok`;
                        })
                        .catch(error => {
                            this.testReport += `${this.$t("status")}: ${this.$t("error")}`;
                            this.testReport += `\r\n${JSON.stringify(error)}`;
                        });

                    let iterationTime = Date.now() - startTime;
                    totalTime += iterationTime;
                    if (this.state == "stopped") {
                        this.testReport += `\r\n${this.$t("stopped")}`;
                        break;
                    }
                }
                this.testReport += "\r\n-------------------------------------";
                this.testReport += `\r\n${this.$t("executionTime")}: ${this.msToTime(totalTime)} (${totalTime} ${this.$t("ms")})`;
                this.testReport += "\r\n=====================================";

                this.testsDuration += totalTime;
            },

            /**
             *  Очистка данных
             */
            clearData () {
                this.testReport = "";
            },

            /**
             *  Обработчик нажатия кнопки очистки данных
             */
            clearDataClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.$refs.MessageDialog.answer      = null;
                this.$refs.MessageDialog.title       = this.$t("clearTheForm");
                this.$refs.MessageDialog.messageText = this.$t("clearFormRequest");

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.dialog",
                    () => {
                        if (this.$refs.MessageDialog.answer) {
                            this.clearData();
                        }
                    }
                );

                this.$refs.MessageDialog.dialog = true;
            },

            /**
             *  Выполнение заданного количества тестов поиска оптимального диаметра
             */
            async diamOptTest () {
                let totalTime = 0;

                if (this.state == "stopped") { return; }

                this.testReport += `\r\n\r\n${this.$t("test")} "${this.$t('findingTheOptimalDiameter')}" ${this.$t("started").toLowerCase()}`;

                for (let i = 0; i < this.amount; i++) {
                    let startTime = Date.now();

                    let patternNum = Math.floor(Math.random() * this.patterns.length);
                    let pattern    = JSON.parse(this.patterns[patternNum].dataJSON);
                    //pattern.name   = this.selectedPattern.name;
                    pattern.du     = pattern.Du;
                    //pattern.species = this.selectedPattern.speciesTranslated;
                    pattern.date   = pattern.updatedAt;

                    let task = {
                        speciesId: 1, //parseInt(this.selectedSpecies.id),
                        l:         Math.floor(Math.random() * 8 + 2),
                        taper:     Math.floor(Math.random() * 25 + 2),
                        curvature: [
                            parseFloat(Math.random().toFixed(1)),
                            parseFloat((Math.random()*1+1).toFixed(1))
                        ],
                        patternId: this.patterns[patternNum].id,
                        pattern:   pattern,
                        minBoardL: Math.floor(Math.random() * 8 + 2),
                    };

                    if (task.l < task.minBoardL) {
                        task.minBoardL = task.l-1;
                    }

                    await this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}tasks/`,
                        data: {
                            type:     2,    // 1 - Оптимизация раскроя, 2 - Поиск оптимального диаметра, 3 - пересчёт постава
                            dataJSON: JSON.stringify(task)
                        },
                        withCredentials: true
                    }).then(async (response) => {
                        this.testReport += `\r\n${i + 1}. URI: ${this.$config.apiURL}tasks/: ${Date.now() - startTime} ${this.$t("ms")}. ${this.$t("status")}: Ok. `;

                        await this.callExternalApp(response.data.task.id);
                    }).catch(error => {
                        this.testReport += `${this.$t("status")}: ${this.$t("error")}`;
                        this.testReport += `\r\n${JSON.stringify(error)}`;
                    });

                    let iterationTime = Date.now() - startTime;
                    totalTime += iterationTime;
                    if (this.state == "stopped") {
                        this.testReport += `\r\n${this.$t("stopped")}`;

                        break;
                    }
                }
                this.testReport += "\r\n-------------------------------------";
                this.testReport += `\r\n${this.$t("executionTime")}: ${this.msToTime(totalTime)} (${totalTime} ${this.$t("ms")})`;
                this.testReport += "\r\n=====================================";

                this.testsDuration += totalTime;
            },

            /**
             *  Выполнение заданного количества тестов оборудования
             */
            async equipmentTest () {
                let totalTime = 0;

                if (this.state == "stopped") { return; }

                this.testReport += `\r\n\r\n${this.$t("test")} "${this.$t('equipment')}" ${this.$t("started").toLowerCase()}`;

                for (let i = 0; i < this.amount; i++) {
                    let startTime = Date.now();

                    let lineNum = Math.floor(Math.random() * this.profiles.length);
                    await this.axios.get(`${this.$config.apiURL}lines/${this.profiles[lineNum].id}/`, { withCredentials: true })
                        .then(() => {
                            this.testReport += `\r\n${i + 1}. URI: ${this.$config.apiURL}lines/${this.profiles[lineNum].id}/ ${this.$t("executionTime")}: ${Date.now() - startTime} ${this.$t("ms")}. ${this.$t("status")}: Ok`;
                        })
                        .catch(error => {
                            this.testReport += `${this.$t("status")}: ${this.$t("error")}`;
                            this.testReport += `\r\n${JSON.stringify(error)}`;
                        });

                    let iterationTime = Date.now() - startTime;
                    totalTime += iterationTime;
                    if (this.state == "stopped") {
                        this.testReport += `\r\n${this.$t("stopped")}`;
                        break;
                    }
                }
                this.testReport += "\r\n-------------------------------------";
                this.testReport += `\r\n${this.$t("executionTime")}: ${this.msToTime(totalTime)} (${totalTime} ${this.$t("ms")})`;
                this.testReport += "\r\n=====================================";

                this.testsDuration += totalTime;
            },

            /**
             * Получение данных о пиломатериалах
             */
            loadLumber () {
                this.loading.lumberInfo = true;

                this.axios.get(`${this.$config.apiURL}lumber/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lumberInfo = response.data.lumber

                            this.boardsCentral = [];
                            this.boardsSide    = [];

                            lumberInfo.forEach((item) => {
                                let lenRange = "";

                                JSON.parse(item.LengthsJSON).forEach((lenItem, index) => {
                                    lenRange += index ? ", " : "";
                                    lenRange += lenItem.length.slice(0, -1);
                                });

                                if (item.BoardType == 0 && item.Species.id == this.speciesId) {
                                    this.boardsCentral.push({
                                        id:      item.id,
                                        //uid:     "c" + item.id,
                                        size:    item.Tn + " x " + item.Wn,
                                        sawSize: item.Ts + " x " + item.Ws,
                                        length:  lenRange,
                                        price:   item.Price
                                    });
                                } else if (item.Species.id == this.speciesId) {
                                    this.boardsSide.push({
                                        id:      item.id,
                                        //uid:     "s" + item.id,
                                        size:    item.Tn + " x " + item.Wn,
                                        sawSize: item.Ts + " x " + item.Ws,
                                        length:  lenRange,
                                        price:   item.Price
                                    });
                                }
                            });
                        }

                        this.loading.lumberInfo = false;
                    })
                    .catch(err => {
                        this.loading.lumberInfo = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `LoadTesting.vue -> getLumber: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData"));
                        }
                    });
            },

            /**
             * Загрузка 3D-моделей
             */
            loadModels () {
                this.loading.models = true;

                this.axios.get(`${this.$config.apiURL}3dmodels/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let modelsInfo = response.data.models

                            this.models = [];

                            modelsInfo.forEach((modelInfo) => {
                                let updatedTimestamp = new Date(modelInfo.updatedAt);
                                let dataParsed       = JSON.parse(modelInfo.DataJSON);

                                this.models.push({
                                    id:        modelInfo.id,
                                    fileName:  modelInfo.FileName,
                                    dTop:      dataParsed.head.TopD,
                                    l:         dataParsed.head.L,
                                    curvature: (dataParsed.head.Curvature * .1).toFixed(1),
                                    timeStamp: (new Date(modelInfo.TimeStamp)).toLocaleString(),
                                    //dataJSON:  modelInfo.DataJSON,
                                    updatedAt: updatedTimestamp.toLocaleString(),
                                    updatedAtTimestamp: Date.parse(updatedTimestamp),
                                });
                            });
                        }

                        this.loading.models = false;
                    })
                    .catch(err => {
                        this.loading.models = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `LoadTesting.vue -> loadModels: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelsData"));
                        }
                    });
            },

            /**
             * Загрузка поставов
             */
            loadPatterns () {
                this.loading.patterns = true;

                this.axios.get(`${this.$config.apiURL}patterns/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let patternsInfo = response.data.patterns;

                            this.patterns = [];

                            patternsInfo.forEach((patternInfo) => {
                                let updatedTimestamp = new Date(patternInfo.updatedAt);

                                this.patterns.push({
                                    id:        patternInfo.id,
                                    species:   patternInfo.Species.Name,
                                    speciesTranslated: this.$t(patternInfo.Species.Name),
                                    name:      patternInfo.Name,
                                    Du:        patternInfo.Du,
                                    Dmin:      patternInfo.Dmin,
                                    Dmax:      patternInfo.Dmax,
                                    DLimitMin: patternInfo.DLimitMin,
                                    DLimitMax: patternInfo.DLimitMax,
                                    dataJSON:  patternInfo.DataJSON,
                                    updatedAt: updatedTimestamp.toLocaleString(),
                                    updatedAtTimestamp: Date.parse(updatedTimestamp),
                                    //visible:    patternInfo.visible
                                });
                            });
                        }

                        this.loading.patterns = false;
                    })
                    .catch(err => {
                        this.loading.patterns = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `LoadTesting.vue -> loadPatterns: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData"));
                        }
                    });
            },

            /**
             * Загрузка профилей линий
             */
            loadProfiles () {
                this.loading.profiles = true;

                this.axios.get(`${this.$config.apiURL}lines/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let profilesInfo = response.data.lines

                            profilesInfo.forEach((item) => {
                                this.profiles.push({
                                    id:   item.id,
                                    name: item.Name,
                                    data: item.DataJSON
                                });
                            });
                        }

                        this.loading.profiles = false;
                    })
                    .catch(error => {
                        this.loading.profiles = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadProfiles") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadProfiles") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadProfiles"));
                        }
                    });
            },

            /**
             * Преобразование миллисекунд в запись вида чч:мм:сс.ммм
             *
             * @param {number} millisecs Миллисекунды
             *
             * @returns {string} Строка с временем в формате чч:мм:сс.ммм
             */
            msToTime(millisecs) {
                let ms    = millisecs % 1000;
                millisecs = (millisecs - ms) / 1000;
                let secs  = millisecs % 60;
                millisecs = (millisecs - secs) / 60;
                let mins  = millisecs % 60;
                let hrs   = (millisecs - mins) / 60;

                return ("00" + hrs).slice(-2) + ":" + ("00" + mins).slice(-2) + ":" + ("00" + secs).slice(-2) + "." + ("00" + ms).slice(-3);
            },

            /**
             *  Выполнение заданного количества тестов справочника 3D-моделей
             */
            async modelsTest () {
                let totalTime = 0;

                if (this.state == "stopped") { return; }

                this.testReport += `\r\n\r\n${this.$t("test")} "${this.$t('threeDModels')}" ${this.$t("started").toLowerCase()}`;

                for (let i = 0; i < this.amount; i++) {
                    let startTime = Date.now();

                    let modelNum = Math.floor(Math.random() * this.models.length);
                    await this.axios.get(`${this.$config.apiURL}3dmodels/${this.models[modelNum].id}/`, { withCredentials: true })
                        .then(() => {
                            this.testReport += `\r\n${i + 1}. URI: ${this.$config.apiURL}3dmodels/${this.models[modelNum].id}/ ${this.$t("executionTime")}: ${Date.now() - startTime} ${this.$t("ms")}. ${this.$t("status")}: Ok`;
                        })
                        .catch(error => {
                            this.testReport += `${this.$t("status")}: ${this.$t("error")}`;
                            this.testReport += `\r\n${JSON.stringify(error)}`;
                        });

                    let iterationTime = Date.now() - startTime;
                    totalTime += iterationTime;
                    if (this.state == "stopped") {
                        this.testReport += `\r\n${this.$t("stopped")}`;
                        break;
                    }
                }
                this.testReport += "\r\n-------------------------------------";
                this.testReport += `\r\n${this.$t("executionTime")}: ${this.msToTime(totalTime)} (${totalTime} ${this.$t("ms")})`;
                this.testReport += "\r\n=====================================";

                this.testsDuration += totalTime;
            },

            /**
             *  Выполнение заданного количества тестов оптимизации
             */
            async optimizationTest () {
                let totalTime = 0;

                if (this.state == "stopped") { return; }

                this.testReport += `\r\n\r\n${this.$t("test")} "${this.$t('optimization')}" ${this.$t("started").toLowerCase()}`;

                for (let i = 0; i < this.amount; i++) {
                    let startTime = Date.now();
                    let task = {
                        speciesId: parseInt(this.speciesId),
                        method:    "vol",
                        line:      [],
                        boards: {
                            central: [], //this.boardsCentral,
                            side:    [], //this.boardsSide
                        },
                        log: {
                            dTop:            Math.floor(Math.random() * (500 - 200 + 1) + 200), //992
                            l:               Math.floor(Math.random() * 7 + 2),
                            falseCore:       false,
                            taper:           0,
                            curvature:       parseFloat((Math.random()*2).toFixed(1)),
                            curvatureCenter: 0.5
                        },
                        useWane: false,
                        corelessBoard: {
                            enabled:   false,
                            thickness: 0,
                            price:     0
                        }
                    };

                    this.boardsCentral.forEach((val) => {
                        task.boards.central.push(this.parseBoardInfo(val))
                    });

                    this.boardsSide.forEach((val) => {
                        task.boards.side.push(this.parseBoardInfo(val))
                    });

                    let profileNum = Math.floor(Math.random() * this.profiles.length);

                    JSON.parse(this.profiles[profileNum].data).forEach((val) => {
                        task.line.push(this.parseEquipmentInfo(val));
                    });

                    //this.loading.calculationResult = true;
                    await this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}tasks/`,
                        data: {
                            type:     1,    // 1 - Оптимизация раскроя, 2 - Поиск оптимального диаметра, 3 - пересчёт постава
                            dataJSON: JSON.stringify(task)
                        },
                        withCredentials: true
                    }).then(async (response) => {
                        this.testReport += `\r\n${i + 1}. URI: ${this.$config.apiURL}tasks/: ${Date.now() - startTime} ${this.$t("ms")}. ${this.$t("status")}: Ok. `;

                        await this.callExternalApp(response.data.task.id);
                    }).catch(error => {
                        this.testReport += `${this.$t("status")}: ${this.$t("error")}`;
                        this.testReport += `\r\n${JSON.stringify(error)}`;
                    });

                    let iterationTime = Date.now() - startTime;
                    totalTime += iterationTime;
                    if (this.state == "stopped") {
                        this.testReport += `\r\n${this.$t("stopped")}`;
                        break;
                    }
                }
                this.testReport += "\r\n-------------------------------------";
                this.testReport += `\r\n${this.$t("executionTime")}: ${this.msToTime(totalTime)} (${totalTime} ${this.$t("ms")})`;
                this.testReport += "\r\n=====================================";

                this.testsDuration += totalTime;
            },

            /**
             * Преобразует информацию о доске в формат для передачи во внешнее приложение
             *
             * @param {object} item Информация о доске
             *
             * @returns {object}
             */
            parseBoardInfo(item) {
                let board = {
                    id:      0,
                    lengths: [],
                    price:   0,
                    tn:      0,
                    wn:      0,
                    ts:      0,
                    ws:      0
                };

                board.id    = item.id;
                board.price = item.price;
                board.tn    = parseInt(item.size.slice(0, item.size.indexOf("x") - 1));
                board.wn    = parseInt(item.size.slice(item.size.indexOf("x") + 1));
                board.ts    = parseFloat(item.sawSize.slice(0, item.sawSize.indexOf("x") - 1));
                board.ws    = parseFloat(item.sawSize.slice(item.sawSize.indexOf("x") + 1));
                item.length.split(",").forEach((num) => {
                    board.lengths.push(parseFloat(num));
                });

                return board
            },

            /**
             * Преобразует информацию об оборудовании в формат для передачи во внешнее приложение
             *
             * @param {object} item Информация об оборудовании
             *
             * @returns {object}
             */
            parseEquipmentInfo(item) {
                let result = {
                    name: "",
                    data: null
                }

                result.name = item.name;

                switch (item.name) {
                    case "rotateAndPositioningDev":
                    case "scanner":
                        result.data = null;
                        break;
                    case "bandSaw":
                        result.data = {
                            kerf: item.data.kerf.val
                        }
                        break;
                    case "circularSaw":
                        result.data = {
                            halfCant:        item.data.halfCant.val,
                            halfCantEnabled: item.data.halfCantEnabled.val,
                            kerf:            item.data.kerf.val,
                            kerfExt:         item.data.kerfExt.val,
                            maxAmount:       item.data.maxAmount.val,
                            sawsThicknessByKerfHeight: item.data.sawsThicknessByKerfHeight.val
                        }
                        break;
                    case "edgeTrimmer":
                        result.data = {
                            kerf:                item.data.kerf.val,
                            maxAmount:           item.data.maxAmount.val,
                            optimizationByWidth: item.data.optimizationByWidth.val,
                            sameWidthSides:      item.data.sameWidthSides.val,
                            twoRowsAfterFrame:   item.data.twoRowsAfterFrame.val
                        }
                        break;
                    case "fbs":
                        result.data = {
                            maxCantThickness:      item.data.maxCantThickness.val,
                            maxCuttingDepth:       item.data.maxCuttingDepth.val,
                            minTopSideBoardsWidth: item.data.minTopSideBoardsWidth.val
                        }
                        break;
                    case "multiSaw":
                        result.data = {
                            kerf:                 item.data.kerf.val,
                            maxAmount:            item.data.maxAmount.val,
                            patternType:          item.data.patternType.val,
                            sawWidthDependOnKerf: item.data.sawWidthDependOnKerf.val
                        }
                        break;
                    case "profilingMachine":
                        result.data = {
                            centralBoardsThicknessMin: item.data.centralBoardsThicknessMin.val,
                            maxProfilingDepth:         item.data.maxProfilingDepth.val,
                            sideBoardsMax:             item.data.sideBoardsMax.val
                        }
                }

                return result;
            },

            /**
             *  Выполнение заданного количества тестов справочника поставов
             */
            async patternsTest () {
                let totalTime = 0;

                if (this.state == "stopped") { return; }

                this.testReport += `\r\n\r\n${this.$t("test")} "${this.$t('patterns')}" ${this.$t("started").toLowerCase()}`;

                for (let i = 0; i < this.amount; i++) {
                    let startTime = Date.now();

                    let patternNum = Math.floor(Math.random() * this.patterns.length);
                    await this.axios.get(`${this.$config.apiURL}patterns/${this.patterns[patternNum].id}/`, { withCredentials: true })
                        .then(() => {
                            this.testReport += `\r\n${i + 1}. URI: ${this.$config.apiURL}patterns/${this.patterns[patternNum].id}/ ${this.$t("executionTime")}: ${Date.now() - startTime} ${this.$t("ms")}. ${this.$t("status")}: Ok`;
                        })
                        .catch(error => {
                            this.testReport += `${this.$t("status")}: ${this.$t("error")}`;
                            this.testReport += `\r\n${JSON.stringify(error)}`;
                        });

                    let iterationTime = Date.now() - startTime;
                    totalTime += iterationTime;
                    if (this.state == "stopped") {
                        this.testReport += `\r\n${this.$t("stopped")}`;
                        break;
                    }
                }
                this.testReport += "\r\n-------------------------------------";
                this.testReport += `\r\n${this.$t("executionTime")}: ${this.msToTime(totalTime)} (${totalTime} ${this.$t("ms")})`;
                this.testReport += "\r\n=====================================";

                this.testsDuration += totalTime;
            },

            /*
            pauseTests () {
                this.state = "paused";
            },
            */

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             *  Запуск тестов
             */
            async startTests () {
                this.state = "run";

                if (this.tests.catalogs.equipment) { await this.equipmentTest(); }
                if (this.tests.catalogs.lengths)   { await this.catalogTest("lengths"); }
                if (this.tests.catalogs.lumber)    { await this.catalogTest("lumber"); }
                if (this.tests.catalogs.prices)    { await this.catalogTest("prices"); }
                if (this.tests.catalogs.species)   { await this.catalogTest("species"); }

                if (this.tests.libraries.patterns) { await this.patternsTest(); }
                if (this.tests.libraries.threeD)   { await this.modelsTest(); }

                if (this.tests.calculations.diamOptimization) { await this.diamOptTest(); }
                if (this.tests.calculations.optimization)     { await this.optimizationTest(); }

                this.testReport += `\r\n${this.$t("totalExecutionTime")}: ${this.msToTime(this.testsDuration)} (${this.testsDuration} ${this.$t("ms")})`;

                this.state = "stopped";
            },

            /**
             *  Прерывание выполнения тестов
             */
            stopTests () {
                this.state = "stopped";
            },
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 144px)
</style>
